import { comparisonData } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-foreground-950 text-2xl md:text-[2.75rem] font-heading font-bold leading-tight mb-4">
            Why Mulebuy Spreadsheet <span className="italic font-light">Matters</span>
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-[640px] mx-auto">
            See how the structured mulebuy spreadsheet approach compares to traditional browsing methods
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="overflow-hidden rounded-2xl border border-background-200/70">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-foreground-950">
                  <th className="text-left py-4 px-6 text-background-50 text-sm font-semibold">Feature</th>
                  <th className="text-left py-4 px-6 text-background-50 text-sm font-semibold">
                    <span className="flex items-center gap-2">
                      <i className="ri-check-line text-accent-400"></i>
                      Mulebuy Spreadsheet System
                    </span>
                  </th>
                  <th className="text-left py-4 px-6 text-background-50 text-sm font-semibold">Traditional Browsing</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, i) => (
                  <tr
                    key={row.feature}
                    className={`border-b border-background-200/50 ${
                      i % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
                    }`}
                  >
                    <td className="py-4 px-6 text-sm font-semibold text-foreground-800">{row.feature}</td>
                    <td className="py-4 px-6 text-sm text-accent-700 font-medium">{row.mulebuy}</td>
                    <td className="py-4 px-6 text-sm text-foreground-500">{row.traditional}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-8 text-center">
            <p className="text-foreground-500 text-sm">
              Data updated weekly — based on aggregated user feedback and structured comparison analysis
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}